import {
  Button,
  ButtonGroup,
  ButtonProps,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
} from "@mui/material"
import { ArrowDropDownIcon } from "@mui/x-date-pickers"
import { ReactElement, useRef, useState } from "react"

type ButtonDropdownProps = {
  label: string
  icon?: ButtonProps["startIcon"]
  children: ReactElement
}

const ButtonDropdown = (props: ButtonDropdownProps) => {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLDivElement>(null)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: Event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return
    }

    setOpen(false)
  }

  return (
    <>
      <ButtonGroup variant="contained" ref={anchorRef}>
        <Button startIcon={props.icon} onClick={handleToggle} sx={{ px: 1 }}>
          {props.label}
        </Button>
        <Button
          size="small"
          aria-expanded={open ? "true" : undefined}
          aria-label="Actions dropdown button"
          aria-haspopup="menu"
          sx={{ px: 1 }}
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{ zIndex: 1 }}
        open={open}
        keepMounted
        anchorEl={anchorRef.current}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper sx={{ display: open ? undefined : "none" }}>
              <ClickAwayListener onClickAway={handleClose}>{props.children}</ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  )
}

export default ButtonDropdown
